/** UID shown like `${tag} -${number}` (e.g. V -101) */
export function formatUidDisplay(tag, number) {
  const t = String(tag ?? "").trim();
  const n = String(number ?? "").trim();
  if (!t && !n) return "";
  return `${t} -${n}`;
}

export function makeLocalId() {
  return `local-${crypto.randomUUID?.() ?? `${Date.now()}-${Math.random()}`}`;
}
